import { ExcelStyle } from "@ag-grid-community/core";

// ids map to cell css classes, look for "mb-cell-value-type-" in MaybernTableColumnTypes
export const MaybernTableExcelStyle: ExcelStyle[] = [
  {
    id: "mb-cell-value-type-text",
    dataType: "String",
  },
  {
    id: "mb-cell-value-type-money",
    dataType: "Number",
    numberFormat: {
      format: "_($* #,##0.00_);[Red]_($* (#,##0.00);_($* -??_)",
    },
  },
  {
    id: "mb-cell-value-type-decimal",
    dataType: "Number",
    numberFormat: {
      format: "#,##0",
    },
  },
  {
    id: "mb-cell-value-type-percent",
    dataType: "Number",
    numberFormat: {
      format: "0.00%;[Red]0.00%",
    },
  },
  {
    id: "mb-cell-value-type-date",
    dataType: "DateTime",
    numberFormat: {
      format: "m/d/yyyy",
    },
  },
  {
    id: "mb-cell-value-type-boolean",
    dataType: "Boolean",
  },
];
